<template>
  <div class="ratings-overlay">
    <div class="ratings-modal">
      <div class="modal-header">
        <span class="title2 header-title">
          {{title}}
        </span>
        <span class="header-desc text2">
          {{desc}}
        </span>
      </div>
      <div class="modal-stars">
        <div class="star-container">
          <div
              v-for="index in 5"
              :key="index"
              class="star"
              @click="setRating(index)"
          >
            <svg v-if="index > rating" width="42" height="42" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.0489 0.927051C16.3483 0.00574017 17.6517 0.00574017 17.9511 0.927051L21.2658 11.1287C21.3996 11.5407 21.7836 11.8197 22.2168 11.8197H32.9434C33.9122 11.8197 34.3149 13.0593 33.5312 13.6287L24.8532 19.9336C24.5027 20.1883 24.3561 20.6396 24.4899 21.0517L27.8046 31.2533C28.104 32.1746 27.0495 32.9407 26.2658 32.3713L17.5878 26.0664C17.2373 25.8117 16.7627 25.8117 16.4122 26.0664L7.73419 32.3713C6.95048 32.9407 5.896 32.1746 6.19535 31.2533L9.51006 21.0517C9.64393 20.6396 9.49728 20.1883 9.14679 19.9336L0.468768 13.6287C-0.314945 13.0593 0.0878303 11.8197 1.05655 11.8197H11.7832C12.2164 11.8197 12.6004 11.5407 12.7342 11.1287L16.0489 0.927051Z" fill="#ECECEC"/>
            </svg>
            <svg v-else width="42" height="42" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.0489 0.927051C16.3483 0.00574006 17.6517 0.00574006 17.9511 0.927051L21.2658 11.1287C21.3996 11.5407 21.7836 11.8197 22.2168 11.8197H32.9434C33.9122 11.8197 34.3149 13.0593 33.5312 13.6287L24.8532 19.9336C24.5027 20.1883 24.3561 20.6396 24.4899 21.0517L27.8046 31.2533C28.104 32.1746 27.0495 32.9407 26.2658 32.3713L17.5878 26.0664C17.2373 25.8117 16.7627 25.8117 16.4122 26.0664L7.73419 32.3713C6.95048 32.9407 5.896 32.1746 6.19535 31.2533L9.51006 21.0517C9.64393 20.6396 9.49728 20.1883 9.14679 19.9336L0.468768 13.6287C-0.314945 13.0593 0.0878302 11.8197 1.05655 11.8197H11.7832C12.2164 11.8197 12.6004 11.5407 12.7342 11.1287L16.0489 0.927051Z" fill="#FFD54A"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="modal-button">
        <button
            class="submit-button buttonL"
            :class="{ 'disabled': rating === 0 }"
            :disabled="rating === 0"
            @click="submitRating"
        >
          제출
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {logEvent} from "@/tarot_box/helper/native_api";

export default {
  name: "LoaderImage",
  data() {
    return {
      rating: 0,
    }
  },
  props: {
    title:{
      type: String,
      default: "마이타로 앱이 마음에 드셨나요?"
    },
    desc:{
      type: String,
      default: "남겨주신 별점은 마이타로 앱 운영과 컨텐츠 제작에 큰 도움이 돼요"
    },
    from:{
      type: String,
      default: "none"
    }
  },
  mounted() {
    logEvent('rating_popup', {
      'from': this.from
    })
    this.appCommander.callAppAction('set_popup_shown', {popup_id: 'ratings'});
  },
  inject: ['appCommander'],
  methods: {
    setRating(value) {
      this.rating = value;
    },
    submitRating() {
      if (this.rating > 0) {
        console.log(this.rating)
        logEvent('rating_popup_done', {
          'rating': this.rating,
          'from': this.from
        })
        this.$emit('submit-rating', this.rating);
        if (this.rating === 5) {
          this.appCommander.callAppAction('request_review', {});
        }
      }
      this.rating = 0;
    }
  }
}
</script>

<style scoped>
.ratings-overlay {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  max-width: 480px;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.ratings-modal{
  width: calc(100vw - 56px);
  max-width: calc(480px - 56px);
  padding: 16px;
  box-sizing: border-box;
  background: white;
  border-radius: 8px;
}

.modal-header{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px;
  box-sizing: border-box;
  text-align: center;
}

.header-title{
  width: 60%;
  word-break: keep-all;
}

.header-desc{
  width: 90%;
  word-break: keep-all;
  color: #555555FF;
}

.modal-stars {
  padding: 16px 0 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.star-container {
  display: flex;
  width: 100%;
  gap: 15px;
  justify-content: center;
  align-items: center;
}

.star {
  width: 40px;
  height: auto;
  transition: transform 0.2s;
}

.star:hover {
  transform: scale(1.1);
}

.modal-button{
  width: 100%;
}

.submit-button{
  width: 100%;
  height: 44px;
  background: var(--Color-palette-Primary-Default);
  color: white;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.submit-button.disabled {
  background-color: var(--Color-palette-Primary-Lighten3);
  cursor: not-allowed;
  color: white;
}

.submit-button:not(.disabled):active {
  background-color: var(--Color-palette-Primary-Lighten3);
}
</style>